import Vue from 'vue'
import Cookies from 'js-cookie'
import { invalidTokenCheckAndHandler } from './invalidTokenCheckAndHandler'
import {v1 as uuidv1} from 'uuid';

export interface IReport {
  applicationId: 'H5'
  locale: string
  bizType: 'LIVENESS_DETECTION_H5'
  info: {
    mobileInfo: {
      userAgent: string,
    }
    detail: IReportDetail,
  }
  sdkVersion: string
  eventType: string
  eventTimestamp: number
  eventCostInMilliSeconds: number,
}

export interface IReportDetail {
  reportUuid?: string,
  userId?: string,

  state?: 'PRE_CHECK' | 'RESOLVE' | 'UPLOAD',
  result?: boolean,
  message?: string,

  videoFileFullName?: string,
  videoDuration?: number,

  videoOrigFormat?: string,
  videoOrigSize?: number,
  videoOrigWidth?: number,
  videoOrigHeight?: number,

  isResolved?: boolean,
  resolveType?: string,
  resolveTime?: number,
  videoResolvedFormat?: string,
  videoResolvedSize?: number,
  videoResolvedWidth?: number,
  videoResolvedHeight?: number,

  uploadTime?: number,
  transactionId?: string,
  score?: number,
  tryCount?: number,
  returnUrl?: string,
  failedReturnUrl?: string
}

function getReportUuid() {
  if (Cookies.get('REPORT_UUID')) {
    return Cookies.get('REPORT_UUID')
  }
  Cookies.set('REPORT_UUID', uuidv1())
  return Cookies.get('REPORT_UUID')
}

export function getReport(): IReport {
  const fullPath = window.location.href
  const subPath = fullPath.lastIndexOf('/')
  let version = 'new'
  if (fullPath.substr(subPath + 1).includes('home-v1')) {
    version = 'old'
  }
  return {
    applicationId: 'H5',
    locale: navigator.language,
    bizType: 'LIVENESS_DETECTION_H5',
    info: {
      mobileInfo: {
        userAgent: navigator.userAgent,
      },
      detail: {
        reportUuid: getReportUuid(),
      },
    },
    sdkVersion: `${process.env.VERSION} ${version}` || version,
    eventType: 'REPORT',
    eventTimestamp: -1,
    eventCostInMilliSeconds: -1,
  }
}

export async function sendReport(report: IReport, message?: string, isJump?: boolean) {
  try {
    const { data: { code } }  =  await Vue.prototype.$http.post('/openapi/side/v1/event-tracking', report)
    // No prompt popup & token expired
    if (message && isJump) {
      invalidTokenCheckAndHandler(code)
    }
  } catch (e) {
    console.log('report error', report, e)
  }
}
